import axios from "axios";
import moment from "moment";

export default class ApiService {
  getInitializedApi(url, method = "get", params = null, is_api = true) {
    return new Promise((resolve, reject) => {
      let data = method === "get" ? { params } : { data: params };
      return axios({
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method,
        baseURL: this.base() + `${is_api ? "/api" : ""}`,
        url,
        ...data,
      })
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getClientsRequests() {
    return this.getInitializedApi("client", "get");
  }
  getAllClientsRequests() {
    return this.getInitializedApi("client", "get", { view: "all" });
  }

  getClientRequest(id) {
    return this.getInitializedApi(`client/${id}`, "get");
  }
  getDiscountRequests() {
    return this.getInitializedApi("discount", "get");
  }
  initNewDiscount(payload) {
   return this.getInitializedApi('discount', "post", payload)
  }
  getSingleDiscount(id) {
      return this.getInitializedApi(`discount/${id}`, 'get')
  }
  setAllDiscount(payload) {
    return this.getInitializedApi(`discount/${payload.id}`, "patch", payload);
  }
  updateSingleDiscount(payload) {
    return this.getInitializedApi(`discount/${payload.id}`, "patch", payload);
  }
  deleteSingleDiscount(id) {
      return this.getInitializedApi(`discount/${id}`, "delete");
  }

  setClientDiscount(id, payload) {
    return this.getInitializedApi(
      `discount/set_discount/${id}`,
      "patch",
      payload
    );
  }

  setNewPassword(id, password) {
    const object = {
      password
    }
    return this.getInitializedApi(`client/${id}/set_password`, 'post', object)
  }

  login(payload) {
    return this.getInitializedApi("api/auth/login", "post", payload, false);
  }

  logout() {
    return this.getInitializedApi("api/auth/logout", "post", null, false);
  }

  getUser() {
    return this.getInitializedApi("user");
  }

  updateClient(payload) {
    return this.getInitializedApi(`client/${payload.id}`, "patch", payload);
  }

  createClient(payload) {
    return this.getInitializedApi("client", "post", payload);
  }

  deleteClient(id) {
    return this.getInitializedApi(`client/${id}`, "delete");
  }

  discountsClientRequest() {
    return this.getInitializedApi("client/discount", "get");
  }

  getCalendarRequest(filter) {
    return this.getInitializedApi("schedule", "get", {
      start: filter.startDay,
      end: filter.endDay,
      filial_id: filter.filial && filter.filial?.id,
      group_id: filter.group && filter.group.id,
      trainer_id: filter.trainer && filter.trainer.id,
    });
  }

  getCalendarTrainerRequest(schedule) {
    return this.getInitializedApi("schedule", "get", {
      start: schedule.start,
      end: schedule.end,
      trainer_id: schedule.trainer_id,
    });
  }

  createSchedule(payload) {
    return this.getInitializedApi(`schedule`, "post", payload);
  }
  updateSchedule(id, payload) {
    return this.getInitializedApi(`schedule/${id}`, "patch", payload);
  }
  getSchedule(id) {
    return this.getInitializedApi(`schedule/${id}`, "get");
  }
  deleteSchedule(id) {
    return this.getInitializedApi(`schedule/${id}`, "delete");
  }

  appendShedule(payload) {
    return this.getInitializedApi(`schedule/append`, "post", payload);
  }
  groupsSchedulePeriod(payload) {
    return this.getInitializedApi("schedule/create", "post", payload);
  }

  getChildrenRequest(id) {
    return this.getInitializedApi("schedule/" + id, "get");
  }

  childrenRequested() {
    return this.getInitializedApi("children", "get");
  }

  childRequest(id) {
    return this.getInitializedApi(`children/${id}`, "get");
  }

  updateChild(payload) {
    return this.getInitializedApi(`children/${payload.id}`, "patch", payload);
  }

  createChild(payload) {
    return this.getInitializedApi(`children`, "post", payload);
  }

  deleteChild(payload) {
    return this.getInitializedApi(`children/${payload.id}`, "delete");
  }

  branchesRequest() {
    return this.getInitializedApi("filial", "get");
  }

  branchRequest(id) {
    return this.getInitializedApi(`filial/${id}`, "get");
  }

  branchCreate(payload) {
    return this.getInitializedApi(`filial`, "post", payload);
  }

  updateBranch(payload) {
    return this.getInitializedApi(`filial/${payload.id}`, "patch", payload);
  }

  branchDelete(id) {
    return this.getInitializedApi(`filial/${id}`, "delete");
  }

  paymentProfilesRequest() {
    return this.getInitializedApi("payment-profile", "get");
  }

  paymentProfileCreate(payload) {
    return this.getInitializedApi("payment-profile", "post", payload);
  }

  paymentProfileUpdate(payload) {
    return this.getInitializedApi(`payment-profile/${payload.id}`, "patch", payload);
  }

  paymentProfileDelete(id) {
    return this.getInitializedApi(`payment-profile/${id}`, "delete");
  }

  groupsRequest() {
    return this.getInitializedApi("group", "get");
  }

  groupRequest(id) {
    return this.getInitializedApi(`group/${id}`, "get");
  }
  discountsGroupRequest() {
    return this.getInitializedApi("group/discount", "get");
  }

  baseCostInvoiceRequest () {
      return this.getInitializedApi('options/invoice_base_price', "get")
  }
  baseCostTrainerRequest () {
      return this.getInitializedApi('options/trainer_base_salary', "get")
  }

  baseCostUpdateRequest (payload) {
      return this.getInitializedApi('options/invoice_base_price', 'put', payload)
  }
  baseCostTrainerUpdateRequest (payload) {
      return this.getInitializedApi('options/trainer_base_salary', 'put', payload)
  }

  createGroup(payload) {
    return this.getInitializedApi(`group`, "post", payload);
  }

  updateGroup(payload) {
    return this.getInitializedApi(`group/${payload.id}`, "patch", payload);
  }

  groupDelete(id) {
    return this.getInitializedApi(`group/${id}`, "delete");
  }
  groupSchedule(id, children_id, payload) {
    console.log("тут 1");
    let params = {
        children_id,
        start: moment()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
    }
    if (payload) {
        const {start, end} = payload
        params.start = start
        params.end = end
    }
    return this.getInitializedApi(`group/schedule/${id}`, "get", params);
  }
  groupScheduleForClient(id) {
    console.log("тут 2");
    return this.getInitializedApi(`group/schedule/${id}`, "get", {
      start: moment().format("YYYY-MM-DD"),
    });
  }
  groupScheduleForClientTraining(id) {
    console.log("тут 3");
    return this.getInitializedApi(`group/schedule/${id}`, "get", {
      start: moment().add(1, "days").format("YYYY-MM-DD"),
      end: moment().endOf("month").add(1, "days").format("YYYY-MM-DD"),
    });
  }
  groupScheduleForAdminInvoice(id, startDate) {
    console.log("тут 4");
    return this.getInitializedApi(`group/schedule/${id}`, "get", {
      start: moment(startDate).startOf("month").format("YYYY-MM-DD"),
      end: moment(startDate).endOf("month").add(1, "days").format("YYYY-MM-DD"),
    });
  }

  groupDiscount(id, payload) {
    return this.getInitializedApi(
      `discount/set_discount/${id}`,
      "patch",
      payload
    );
  }

  trainersRequest() {
    return this.getInitializedApi("trainer", "get");
  }

  trainerRequest(id) {
    return this.getInitializedApi(`trainer/${id}`, "get");
  }

  trainerCreate(payload) {
    return this.getInitializedApi(`trainer`, "post", payload);
  }

  updateTrainer(payload) {
    return this.getInitializedApi(`trainer/${payload.id}`, "patch", payload);
  }

  trainerDelete(id) {
    return this.getInitializedApi(`trainer/${id}`, "delete");
  }

  setTrainerPassword(id, password) {
    return this.getInitializedApi(`trainer/${id}/set_password`, "post", {
      password,
    });
  }

  typeGroupsRequest() {
    return this.getInitializedApi("enums/type_groups", "get");
  }
  sourceClientRequest() {
    return this.getInitializedApi("enums/source", "get");
  }
  statusClientRequest() {
    return this.getInitializedApi("enums/status_client", "get");
  }
  stateTrainingChildren() {
    return this.getInitializedApi("enums/state_training_children", "get");
  }
  statusChildren() {
    return this.getInitializedApi("enums/status_children", "get");
  }
  invoiceState() {
    return this.getInitializedApi("enums/invoice_state", "get");
  }
  scheduleState() {
    return this.getInitializedApi("enums/state_schedule ", "get");
  }
  getTrainingTrial(date) {
    return this.getInitializedApi("training/trial", "get", {
      date: date,
    });
  }
  getTrainingTrialPeriod(date) {
    return this.getInitializedApi("training/trial", "get", {
      start: date.start,
      end: date.end,
    });
  }
  getTrainingTrialToday(date) {
    return this.getInitializedApi("training/trial", "get", {
      date: date,
    });
  }
  updateStateChildrenTraining(id, payload) {
    return this.getInitializedApi(`training/${id}`, "patch", payload);
  }

  getTraining(id) {
    return this.getInitializedApi("training/" + id, "get");
  }

  savePhoto(file, collection, modelId) {
    const formData = new FormData();
    formData.append("media", file);
    return this.getInitializedApi(
      `media/${collection}/${modelId}`,
      "post",
      formData
    );
  }
  delMedia(collection, modelId, mediaId) {
    return this.getInitializedApi(
      `media/${collection}/${modelId}/${mediaId}`,
      "delete"
    );
  }

  getPhoto(collection, modelId) {
    return this.getInitializedApi(`media/${collection}/${modelId}`, "get");
  }

  getKanbanRequests() {
    return this.getInitializedApi("client/crm", "get");
  }

  getTasksRequests() {
    return this.getInitializedApi("task", "get");
  }
  createTask(payload) {
    return this.getInitializedApi(`task`, "post", payload);
  }
  deleteTask(id) {
    return this.getInitializedApi(`task/${id}`, "delete", id);
  }

  getAdminsRequests() {
    return this.getInitializedApi("admin/admin", "get");
  }

  createAdmin(payload) {
    return this.getInitializedApi("admin/admin", "post", payload);
  }

  deleteAdmin(id) {
    return this.getInitializedApi(`admin/admin/${id}`, "delete");
  }

  createHistory(required, payload) {
    return this.getInitializedApi(`history/${required}`, "post", payload);
  }
  invoiceCreate(payload) {
    return this.getInitializedApi(`invoice`, "post", payload);
  }
  payInvoice(id) {
    return this.getInitializedApi(`invoice/banking/${id}`, "get");
  }

  invoiceDeleteBankingHistory(id) {
    return this.getInitializedApi(`invoice/banking/clear/${id}`, "delete");
  }

  getInvoice(id) {
    return this.getInitializedApi(`invoice/${id}`, "get");
  }

  invoicesRequest(payload = {}) {
    return this.getInitializedApi("invoice", "get", payload);
  }

  invoiceToPay(id, comment) {
    return this.getInitializedApi(`invoice/to_pay/${id}`, "patch", {
      comment: comment,
    });
  }
  invoiceTrainingMove(payload) {
    return this.getInitializedApi("invoice/move", "patch", payload);
  }
  invoiceDelete(id) {
    return this.getInitializedApi(`invoice/${id}`, "delete");
  }

  getMainScreenRequest() {
    return new Promise((resolve, reject) => {
      return axios
        .get(this.base() + "/api/desktop/stat")
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => reject(error));
    });
  }
  updateUser(payload) {
    return this.getInitializedApi(`user`, "patch", payload);
  }
  updatePasswordUser(payload) {
    return this.getInitializedApi(`user/password`, "patch", payload);
  }
  resetPasswordUser(email) {
    return this.getInitializedApi(`user/reset`, "post", { email: email });
  }
  getAnalyticData(from, to, group_by, payment_profile_id) {
    const params = {
      from,
      to,
      group_by,
    };
    if (payment_profile_id) {
      params.payment_profile_id = payment_profile_id;
    }
    return this.getInitializedApi("analytic/income", "get", params);
  }
  base() {
    let current_url = window.location.href;
    let arr = current_url.split("/");
    let base_path = arr[0] + "//" + arr[2];
    base_path = base_path.replace("localhost:3000", "devops.manags.ru");
    return base_path;
  }
}
